import i18n from "../i18n"
const mixinVModel = {
  props: ['value', 'id', 'required'],
  watch: {
    localValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.localValue = newValue
    }
  },
  data() {
    return {
      localValue: this.value,
      showError: false,
      messageError: i18n.t('common_words.message_error')
    }
  },
  methods: {
    highlightItem(className) {
      for (let index of document.getElementsByClassName(className)) {
        let sel = index.getElementsByClassName("el-input__inner")[0]
        sel.focus()
        sel.classList.add("custom-has-error")
        this.removeHasError(sel)
      }
    },
    async removeHasError(index) {
      if (index.classList.contains("el-input__inner")) {
        setTimeout(() => {
          index.classList.remove("custom-has-error")
        }, 3000)
      }
      return true
    },
    validate() {
      if ((this.required === 1 && !this.localValue)) {
        this.highlightItem(`required-value-${this.id}`)
        this.showMessageErrorLabel()
        return false
      }
      return true
    },
    showMessageErrorLabel() {
      this.showError = true
      setTimeout(() => {
        this.showError = false
      }, 3000)
    }
  },
  mounted() {
    this.validate()
  }
}

export default mixinVModel
